<template>
  <div>
    <!-- action buttons -->
    <template v-if="actionButtons != null">
      <span v-for="button in actionButtons" class="button" :key="button.name">
        <!--  v-if="button.onclick != 'printDocument'" -->
        <v-btn class="mr-2" :disabled="processData" @click="buttonClick(button)">{{ button.name
        }}</v-btn>
        <!--print-->
        <!--
        <span v-else>
          <v-btn :href="this.$model.wwwroot + '/procollege/manage_groups/documents3/saveDocument'" target="_blank"
            class="print-template">{{ button.name }}</v-btn>
          <v-btn class="load-template mr-2" @click="showContext" @contextmenu="showContext">
            <div class="arrow-left"></div>
          </v-btn>
        </span>
        -->
      </span>
    </template>
    <!-- контекстоное меню кнопки печати -->

    <v-menu v-model="context.show" :target="[context.x, context.y]" absolute offset-y>
      <v-list>
        <v-list-item>
          <v-list-item-title><label>
              Добавить свой файл...
              <input ref="file" type="file" style="width: 0; height: 0; border: 0; display: inline"
                v-on:change="handleFileUpload()" /> </label></v-list-item-title>
        </v-list-item>
        <template v-if="templates !== null && templates !== undefined">
          <v-list-item v-for="template in templates" :key="template.id">
            <v-list-item-title>
              <a v-if="!template.used" style="color: #337ab7" @click="setNewTemplate(template)" :href="'routers/router.php?action=printDocument&templateId=' +
                template.id +
                '&orderid=' +
                id
                ">{{ template.name }}</a>
              <a v-else style="color: green" @click="setNewTemplate(template)" :href="'routers/router.php?action=printDocument&templateId=' +
                template.id +
                '&orderid=' +
                id
                ">{{ template.name }}</a>
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
    <!-- диалог отправки документа -->
    <v-dialog v-model="dialog.show" v-if="dialog.show" width="600">
      <v-card>
        <v-card-title class="grey lighten-4">{{ dialog.title }}</v-card-title>
        <v-card-text>
          <p>Сотрудник</p>
          <v-autocomplete variant="outlined" :items="nextUsersList" item-title="name" return-object v-model="nextUser"
            clearable chips closable-chips>
            <template v-slot:chip="{ props, item }">
              <v-chip v-bind="props" variant="flat" color="green" :text="item.raw.name"></v-chip>
            </template>
            <template v-slot:item="{ props, item }">
              <v-list-item v-bind="props" :title="item.raw.name"></v-list-item>
            </template>
          </v-autocomplete>
          <br />
          <v-textarea label="Комментарий" v-model="nextUserComment" auto-grow rows="1"></v-textarea>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendTo()">Отправить</v-btn>
          <v-btn color="primary" @click="dialog.show = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  /**
     * saveDocument
     * signatureDocument
     * nextUsers
     * prevUser
     * cancelDocument
     * printDocument
     * deleteDocument
     * reject
     * signature_1  ?? 
     * signature_2	??
   */
  name: "actionButtons",
  emits: [
    "reloadDoc",
    "clearVars",
    "update:processData"//overlay component
  ],
  data() {
    return {
      context: {
        show: false,
        x: 0,
        y: 0,
      },
      dialog: {
        title: "",
        show: false,
        name: false,
      },
      nextUsersList: [],
      nextUser: null,
      nextUserComment: "",
      route: ""
    };
  },
  props: {
    variables: null,
    users: null,
    templates: null,//print templates
    actionButtons: null,
    processData: false
  },
  created() { },
  methods: {
    /*
    в actionButton.onclick записано имя callback'а
    если метод существует-вызывается он
    если нет то отправуляется запрос /procollege/manage_groups/documents3/+callback
    с параметрами orderid,variables
    */
    buttonClick(button) {
      let callback = button.onclick;
      if (typeof this[callback] == "function") {
        this[callback](button);
      } else {
        let params = {
          orderid: this.$route.params.id,
          variables: JSON.stringify(this.variables)
        }

        this.axios
          .post(
            this.$model.wwwroot + "/procollege/manage_groups/documents3/" + callback,
            new URLSearchParams(params)
          )
          .then((response) => {
            this.$emit("reloadDoc", response);
          })
          .catch((error) => {
            this.axiosDefaultErrorHandler(error);
          });

      }
    },
    printDocument() {
      let params = {
        orderid: this.$route.params.id
      }
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/printDocument",
          new URLSearchParams(params),
          {
            responseType: 'blob'
          }
        )
        .then((response) => {
          let link = document.createElement("a");
          link.href = URL.createObjectURL(response.data);

          let filename = "document.docx"
          if (typeof response.headers["content-disposition"] != "undefined") {
            t = response.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (t[1] != "undefined") {
              filename = decodeURIComponent(t[1]);
              filename = filename.replace(/[\"\'\\]/g, '')
            }
          }

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });
    },
    //кнопка сохранить
    saveDocument() {
      let selected = [];
      this.variables.forEach(variable => {
        if (variable.name == "student-list") {
          variable.value = [];
          this.users.forEach(group => {
            variable.value = variable.value.concat(group.selectedStudents)
          });
          selected = variable.value;
        }
      });

      if (!this.validateForm(selected)) {
        return
      }

      this.$emit("update:processData", true);

      let params = {
        orderid: this.$route.params.id,
        documentVariables: JSON.stringify(this.variables),
      }

      //categoryid
      if (this.$store.getters["documentStore/STATE"]) {
        Object.assign(params, this.$store.getters["documentStore/STATE"])
      }

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/saveDocument",
          new URLSearchParams(params)
        )
        .then(async (response) => {
          this.$emit("update:processData", false);
          await this.$router.replace({
            name: this.$route.name,
            params: {
              id: response.data.id
            }
          })

          this.$emit("reloadDoc", response);

          this.$eventBus.$emit("show-dialog", {
            title: "Успешно",
            content: "Сохранено успешно",
          });

        })
        .catch((error) => {
          this.$emit("update:processData", false);
          this.axiosDefaultErrorHandler(error);
        });
    },
    validateForm(selectedStudents) {
      let err = [];
      selectedStudents.forEach(student => {
        if (student['student-group'].editable == 1 && student['student-group'].value.id != 0) {
          //форма обучения должна соотвествовать форме обучения группы
          if (student['student-study'] != undefined && student['student-study'].editable == 1) {
            if (student['student-study'].value.id != student['student-group'].value.form_education) {
              err.push(student.name + ":выбранная форма обучения не соотвествует форме обучения группы")
            }
          }
          //специальность должна специальности группы
          if (student['student-spec-name'] != undefined && student['student-spec-name'].editable == 1) {
            if (student['student-spec-name'].value.id != student['student-group'].value.specialty_id) {
              err.push(student.name + ":выбранная специальность не соотвествует специальности группы")
            }
          }
        }
      });

      if (err.length != 0) {
        this.$eventBus.$emit("show-dialog", {
          title: "Ошибка валидации",
          content: err.join("<br/>"),
        });
        return false;
      }
      return true;
    },
    //кнопка отправить
    nextUsers(button) {
      this.nextUsersList = button.data;
      this.nextUser = null;
      this.nextUserComment = "";
      this.route = "nextUser";
      this.dialog.name = "nextUserDialog";
      this.dialog.title = "Отправить на обработку";
      this.dialog.show = true;
    },
    //кнопка вернуть на доработку
    prevUser(button) {
      this.nextUsersList = button.data;
      this.nextUser = null;
      this.nextUserComment = "";
      this.route = "prevUser";
      this.dialog.name = "prevUserDialog";
      this.dialog.title = "Отправить на доработку";
      this.dialog.show = true;
    },
    //кнопка отклонить
    turnDown(button) {
      this.nextUserComment = "";
      this.dialog.name = "turnDownDialog";
      this.route = "turnDown";
      this.dialog.title = "Отказать";
      this.dialog.show = true;
    },
    signatureDocument(button) {
      let params = {
        orderid: this.$route.params.id
      }
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/signatureDocument",
          new URLSearchParams(params)
        )
        .then((response) => {
          this.$emit("reloadDoc", response);
          this.$emit("update:processData", false);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
          this.$emit("update:processData", false);
        });
    },
    cancelDocument() {
      this.$emit("clearVars");
      let params = {
        orderid: this.$route.params.id
      }

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/cancel",
          new URLSearchParams(params)
        )
        .then((response) => {
          this.$emit("reloadDoc", response);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });
    },
    deleteDocument(button) {
      if (confirm("Вы действительно хотите удалить документ?")) {
        let params = {
          orderid: this.$route.params.id
        }
        //categoryid
        if (this.$store.getters["documentStore/STATE"]) {
          Object.assign(params, this.$store.getters["documentStore/STATE"])
        }
        this.axios
          .post(
            this.$model.wwwroot + "/procollege/manage_groups/documents3/delete",
            new URLSearchParams(params)
          )
          .then((response) => {
            this.$router.replace({
              path: "/documents3/orders/" + params.categoryid,
            });
          })
          .catch((error) => {
            this.axiosDefaultErrorHandler(error);
          });
      }
    },
    sendTo() {
      if (this.nextUser != null) {
        this.$emit("update:processData", true);
        let params = {
          orderid: this.$route.params.id,
          stage: this.nextUser.stage,
          next_users_id: this.nextUser.user_id,
          comment: this.nextUserComment,
        }

        this.axios
          .post(
            this.$model.wwwroot + "/procollege/manage_groups/documents3/" + this.route,
            new URLSearchParams(params)
          )
          .then((response) => {
            this.$emit("reloadDoc", response);
            this.$emit("update:processData", false);
          })
          .catch((error) => {
            this.axiosDefaultErrorHandler(error);
            this.$emit("update:processData", false);
          });

        this.hideDialog();
      }
    },
    hideDialog() {
      this.dialog.show = false;
    },
    //выбор нового шаблона для печати
    setNewTemplate(template) {
      for (let key in this.templates) {
        if (this.templates[key].id == template.id) {
          this.templates[key].used = 1;
        } else {
          this.templates[key].used = 0;
        }
      }
    },
    //загрузка своего шаблона
    handleFileUpload() {
      let data = new FormData();
      let file = this.$refs.file.files[0];
      data.append("file", file);
      data.append("id", this.id);

      this.$postJSON(
        "routers/router.php?action=addCustomDocument",
        data,
        (resp) => {
          if (resp && Number.isInteger(resp.id) && resp.id > 0) {
            EventBus.$emit("show-dialog", "Успешно", "Сохранено успешно");
            this.templates.push(resp);
          }
        }
      );
    },
    showContext(e) {
      e.preventDefault();
      this.context.show = false;
      this.context.x = e.clientX;
      this.context.y = e.clientY;
      this.$nextTick(() => {
        this.context.show = true;
      });
    },
    //выбор нового шалона для печати
    setNewTemplate(template) {
      let templates = this.templates;
      for (let key in templates) {
        if (templates[key].id == template.id) {
          templates[key].used = 1;
        } else {
          templates[key].used = 0;
        }
      }

      this.$emit("update:templates", templates);
    },
  },
};
</script>
<style scoped>
.arrow-left {
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-left-color: steelblue;
  border-right: 0;
  display: inline-block;
}

.print-template {
  border-radius: 4px 0 0 4px;
  min-width: 120px !important;
}

button.load-template {
  padding: 0px !important;
  min-width: 30px !important;
  border-radius: 0 4px 4px 0;
  margin-left: -2px;
}
</style>